const sr = {
    bannerTitle: "Istražite povoljne cene\n" +
        "autobuskih karata za\n" +
        "svoju narednu avanturu",
    bannerSubTitle: "Jednostavno uporedite i rezervišite svoje sledeće putovanje",
    appName: "NS Portal",
    signIn: "Prijavi se",
    signOut: "Odjavi se",
    home: "Početna",
    profile: "Profil",
    startStation: "Početna stanica",
    endStation: "Krajnja stanica",
    startDate: "Datum polaska",
    endDate: "Datum povratka",
    passengers: "Putnici",
    search: "Pretraži",
    optional: "Opciono",
    mostFavDestinations: "Najčesće birane destinacije",
    startingFrom: "već od",
    rsd: "din",
    downloadOurApp: "Preuzmite našu aplikaciju",
    singUpForNotifications: "Prijavite se za sva nova obaveštenja",
    termsOfUse: "Uslovi korišćenja",
    privatePolicy: "Politika privatnosti",
    appDescription: "Sa jednostavnim korisničkim interfejsom, brzim pretragama i sigurnim plaćanjem, naša aplikacija " +
        "vam omogućava da u svega nekoliko koraka rezervišete i kupite autobuske karte iz udobnosti svog mobilnog uređaja. " +
        "Putovanje nikada nije bilo lakše – istražite destinacije, birajte datume i stvarajte nezaboravna iskustva uz našu " +
        "intuitivnu aplikaciju.",
    yourEmailAddress: "Vaša e-adresa",
    passengersDetails: "Detalji putnika",
    seatIsNotSelected: "Mesto sedenja nije definisano",
    selectGender: "Pol",
    male: "Muški",
    female: "Ženski",
    other: "Ostalo",
    selectSeat: "Izaberi sedište",
    contactDetails: "Kontakt podaci",
    countryFrom: "Država rođenja",
    contactPhone: "Kontakt telefon",
    email: "E-pošta",
    checkNotification: "Primaj obaveštenja vezana za ponude",
    documents: "Dokumenti",
    passport: "Pasoš",
    documentNumber: "Broj dokumenta",
    ticketReview: "Pregled karte",
    refund: "Refundiranje",
    noRefund: "Bez refundiranja",
    travelConditions: "Uslovi putovanja",
    condition1: "Kartu je potrebno pokazati vozaču pri ulasku u vozilo",
    condition2: "Kartu možete pronaći na vašem nalogu ili mejlu nakon kupovine",
    baggage: "Prtljag",
    reservationTime: "Važenje rezervacije",
    tripDetail: "Detalji puta",
    invoiceDetails: "Stavke na računu",
    passenger: "Putnik",
    basic: "Osnovica",
    vat: "Porez",
    discount: "Visina popusta",
    discountType: "Vrsta povlastice",
    numberDiscountType: "Broj dokumenta povlastice",
    total: "Ukupno",
    name: "Ime",
    surname: "Prezime",
    phone: "Telefon",
    bDay: "Datum rođenja",
    sex: "Pol",
    street: "Ulica",
    zip: "Poštanski broj",
    city: "Grad",
    state: "Država",
    update: "Ažuriraj",
    chooseRightTransport: "Izaberite odgovarajući prevoz",
    foundResults: "Rezultata",
    cheapest: "Najjeftinija",
    fastest: "Najbrža",
    earliest: "Najranija",
    filter: "Filter",
    numberOfFreeSeats: "Slobodnih mesta",
    numberOfStation: "Broj perona",
    ticketPrice: "CENA KARTE",
    advertisementTitle: "Reklamni deo",
    adults: "Odrasli",
    youth: "Mladi",
    seniors: "Seniori",
    subscribe: "Prijavi se",
    searchResult: "Rezultat pretrage",
    routeDetails: "Detalji relacije",
    buyTicket: "Kupi kartu",
    stationsList: "Vidi sve stanice",
    successfulPurchase: "Uspešna kupovina",
    busTicket: "Autobuska karta",
    invNumber: "Broj računa",
    line: "Linija",
    departure: "Polazak",
    return: "Povratak",
    departureTime: "Vreme polaska",
    returnTime: "Vreme povratka",
    contact: "Kontakt podaci",
    note: "Napomena",
    downloadTicket: "Preuzmi kartu",
    paidAmount: "Uplaćen iznos",
    paymentMethod: "Način plaćanja",
    carrierInfo: "Podaci prevoznika",
    carrierName: "Naziv prevoznika",
    contactNumber: "Kontakt telefon",
    goHome: "Idi na početak",
    pay: "Plati",
    back: "Nazad",
    userProfile: "Profil korisnika",
    personalInfo: "Lične informacije",
    boughtTickets: "Kupljene karte",
    logout: "Odjavi se",
    updatePhoto: "Promeni sliku",
    personalData: "Lični podaci",
    passwordChange: "Izmena lozinke",
    oldPassword: "Stara lozinka",
    newPassword: "Nova lozinka",
    welcomeBack: "Dobrodošli nazad!",
    loginGoogle: "Nastavi uz Google",
    loginEmail: "Nastavi pomoću mejla",
    login: "Prijavi se",
    forgottenPassword: "Zaboravili ste lozinku?",
    dontHaveAcc: "Nemate otvoren nalog? ",
    haveAcc: "Već imate nalog? ",
    registration: "Registruj se",
    password: "Lozinka",
    rePassword: "Ponovi lozinku",
    privilegeType: "Tip polvastice",
    privilegeNumber: "Broj povlastice",
    or: "Ili",
    createAccount: "Napravite nalog",
    receiveNotifications: "Želim da primam obaveštenja o promocijama",
    createAccountDescriptionOne: "Brža kupovina autobuskih karata za naredna putovanja",
    createAccountDescriptionTwo: "Prikaz istorije kupljenih karata i predstojećih putovanja",
    termsAccept: "Kreiranjem naloga prihvatate Uslove i Politiku privatnosti i \n" +
        "saglasni ste da primate e-poruke, na koje možete da se \n" +
        "odjavite u bilo kom trenutku.",
    passwordResetTitle: "Obnovite lozinku",
    backToLogin: "Povratak na prijavljivanje",
    passwordResetText: "Unesite vašu mejl adresu koji ste koristili za \n" +
        "registraciju na portal, i mi ćemo Vam polasti \n" +
        "link za obnovu lozinke.",
    appSectionBulletOneTitle: "Laka Rezervacija, Brzo Putovanje",
    appSectionBulletTwoTitle: "Brze Pretrage po Tvojoj Meri",
    appSectionBulletThreeTitle: "Mobilna Sloboda",
    appSectionBulletOneDesc: "Nudimo ti aplikaciju s jednostavnim korisničkim interfejsom, brzim pretragama i sigurnim plaćanjem. Sve što ti treba je samo nekoliko koraka kako bi rezervisao/la i kupio/la autobuske karte direktno sa svog mobilnog uređaja.",
    appSectionBulletTwoDesc: "Istraži destinacije koje te zanimaju, odaberi datume koji ti odgovaraju, i to sve uz brze pretrage koje ti omogućavaju da uštediš vreme i lako planiraš svoje putovanje.",
    appSectionBulletThreeDesc: "Rezerviši i kupi autobuske karte dok si u pokretu, direktno sa svog mobilnog uređaja. Pružamo ti praktičnost i fleksibilnost da upravljaš svojim putovanjima bilo gde i bilo kada.",
    futureTrips: "Predstojeća putovanja",
    completedTrips: "Realizovana putovanja",
    cancelledTrips: "Otkazana putovanja",
    returnTicket: "Povratna",
    trips: "Putovanja",
    save: "Sačuvaj",

}

export default sr;